
































































































































































import Vue from 'vue'
import VueSticky from '../../../components/sticky'
import Checkbox from '../../../components/Checkbox.vue'

let addNotEmpty: EventListener

export default Vue.extend({
	props: ['settings'],
	components: {
		Checkbox
	},
	data() {
		return {
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			$('[name="oc[topic]"]').styler();
			$('[name="oc[topic]"]').trigger('refresh');
		})
	},
	updated: function () {
		this.$nextTick(function () {
			$('[name="oc[topic]"]').styler();
			$('[name="oc[topic]"]').trigger('refresh');
		})
	},
	methods: {
		getTime(time_before: string, time_after: string): number[] {
			let min: number = +time_before.substr(0, 2)*60 + +time_before.substr(3, 2)
			if (time_before == '') {
				min = 0
			}
			let max: number = +time_after.substr(0, 2)*60 + +time_before.substr(3, 2)
			if (time_after == '') {
				max = 1440
			}
			let b = max
			if (max < min) {
				max = min
				min = b
			}
			console.log(min, max)
			
			let hours = []
			for (let i =  0; i <= Math.floor((max-min) / 60); i++) {
				hours.push(Math.floor(min/60) + i)
			}
			return hours
		}
	},
	directives: {
		'sticky': VueSticky,
		'not-empty': {
			bind(el: Element) {
				let $el = $(el)
				addNotEmpty = () => {
					if ($el.val()) {
						$el.addClass('not-empty')
					} else {
						$el.removeClass('not-empty')
					}
				}
				el.addEventListener('change', addNotEmpty)
			},
			unbind(el: Element) {
				el.removeEventListener('change', addNotEmpty)
			}
		},
		styler: {
			bind(el: Element) {
				$(el).styler();
			},
		}
	},
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/form/FormViewer2.vue